import { render, staticRenderFns } from "./withheldNew.vue?vue&type=template&id=32c38910&"
import script from "./withheldNew.vue?vue&type=script&lang=js&"
export * from "./withheldNew.vue?vue&type=script&lang=js&"
import style0 from "./withheldNew.vue?vue&type=style&index=0&id=32c38910&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports